var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c("b-row", [
            _c("h3", { staticClass: "ml-2" }, [_vm._v("Produtos")])
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { "align-v": "end" } },
            [
              _c(
                "b-col",
                { attrs: { cold: "8" } },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Produto")]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "md-6",
                    attrs: { placeholder: "Código ou Nome" },
                    model: {
                      value: _vm.filtro.produto,
                      callback: function($$v) {
                        _vm.$set(_vm.filtro, "produto", $$v)
                      },
                      expression: "filtro.produto"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "p-3" },
            [
              _c("b-table", {
                attrs: {
                  items: _vm.tableData,
                  fields: _vm.colunas,
                  "show-empty": "",
                  hover: "",
                  striped: "",
                  "per-page": _vm.perPage,
                  filter: _vm.filtro.produto,
                  "filter-included-fields": _vm.filterOn,
                  stacked: "md",
                  "current-page": _vm.currentPage
                },
                on: { filtered: _vm.onFiltered },
                scopedSlots: _vm._u([
                  {
                    key: "cell(imagens)",
                    fn: function(row) {
                      return [
                        row.value && row.value.length > 0 && row.value[0].path
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showImage(row.value)
                                    }
                                  }
                                },
                                [
                                  _c("b-img", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px"
                                    },
                                    attrs: { src: row.value[0].path, fluid: "" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-pagination", {
                    staticClass: "mt-3",
                    attrs: {
                      fill: "",
                      "total-rows": _vm.tableData.length,
                      "per-page": _vm.perPage,
                      "aria-controls": "my-table"
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", "hide-header": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalImagem = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalImagem,
            callback: function($$v) {
              _vm.modalImagem = $$v
            },
            expression: "modalImagem"
          }
        },
        [
          _c(
            "b-carousel",
            {
              staticStyle: { "text-shadow": "1px 1px 2px #333" },
              attrs: {
                id: "carousel-fade",
                fade: "",
                indicators: "",
                "img-width": "600",
                "img-height": "600",
                controls: "",
                background: "#C0C0C0"
              }
            },
            _vm._l(_vm.imagensModal, function(imagem, index) {
              return _c("b-carousel-slide", {
                key: index,
                staticStyle: { "max-width": "600px", "max-height": "600px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "img",
                      fn: function() {
                        return [
                          _c("b-img", {
                            staticClass: "text-center",
                            staticStyle: {
                              "min-width": "600px",
                              "min-height": "600px"
                            },
                            attrs: { src: imagem.path, "fluid-grow": "" }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77dd8ab2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77dd8ab2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-77dd8ab2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/Main.vue
// module chunks = 2